const prefix = process.env.NODE_ENV == 'development' ? 'client-notifications' : 'client-notifications';

export const get_read_notifications = () => `${prefix}/notification?limit=5&read=true`;
export const get_unread_notifications = () => `${prefix}/notification?limit=5`;
export const get_live_notifications = (businessId, userId) =>
    `${process.env.REACT_APP_API_BASE_URL}/${prefix}/live?businessAccountId=${businessId}&userId=${userId}`;
export const dismiss_all_notifications = `${prefix}/notification/dismiss`;
export const dismiss_single_notification = (id) => `${prefix}/notification/dismiss/${id}`;
export const delete_single_notification = (id) => `${prefix}/notification/${id}`;
